import React, { useEffect, useState } from 'react';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DashboardHomeItem } from '../components/DashboardHomeItem';
import Twitter from '../components/Twitter';
import { Dashboard } from '../interfaces/Dashboard';
//import { iconesMap } from '../lib/icones';
import Collapsible from '../components/Collapsible';

interface CategoriesData {
  [key: string]: Dashboard[];
}

interface HomeProps {
  dashboards: Dashboard[];
  categoriesDomain: CategoriesData;
}

function Home({ dashboards, categoriesDomain }: HomeProps) {
//  const [filteredDashboards, setFilteredDashboards] = useState<Dashboard[]>([]);
  const [busca, setBusca] = useState('');
  const [domainDash, setDomainDash] = useState<CategoriesData>({});

  useEffect(() => {
    let filteredData: CategoriesData = {};
    for (const domain in categoriesDomain) {
      filteredData[domain] = categoriesDomain[domain].slice(0,5).filter(dashboard => {
        const regex = new RegExp(busca, 'i');
        const nameMachSearch = dashboard.name.match(regex)
        const tagsMachSearch = dashboard.tags.reduce((prev, current) => prev || !!current.match(regex), false)
        const descriptionMachSearch = dashboard.description.match(regex)
        return nameMachSearch || tagsMachSearch || descriptionMachSearch;
        }
      );
    }
    setDomainDash(filteredData);
  }, [dashboards, categoriesDomain, busca]);

  // function handleInputChange(event: React.FormEvent<HTMLInputElement>) {
  //   event.preventDefault();
  //   setBusca(event.currentTarget.value);
  // }

  return (
    <div className="conteudo-home">
      <main>
        <div className='home-header'>
          <h1>Sala de situação</h1>
          {/* <Collapsible title=""><Twitter/></Collapsible> */}
          {/* <div className="input-group busca-capa">
            <input
              type="text"
              onChange={handleInputChange}
              value={busca}
              placeholder="Buscar conteúdos"
            />
            <div className="input-group-append">
              <FontAwesomeIcon icon={iconesMap["Busca"]} className="fa-xl" aria-hidden="true"/>
            </div>
          </div> */}
        </div>
        <div className='mais-acessados'>
          <h2>Mais acessados</h2>
          {/* <p className='contador-paineis'>
            <strong>{filteredDashboards.length}</strong> {filteredDashboards.length === 1 ? "painel encontrado." : "painéis encontrados."}
          </p> */}
        </div>
        {/* mexer aqui!!! */}
        <div className="grid-3col">
          {Object.keys(domainDash).map((domain) => (
            <div>
              {/* {domain === 'Segurança Pública' ? <span><strong>Segurança Pública </strong><small>- em implantação</small></span> : <></>} */}
              {/* {domain === 'Serviços Urbanos' ? <span><strong>Serviços Urbanos </strong><small>- em revisão</small></span> : <></>} */}
              {/* {domain !== 'Serviços Urbanos' && domain !== 'Segurança Pública' ? <strong>{domain}</strong> : <></>} */}
              <strong>{domain}</strong>
                <div>
                  {domainDash[domain].map((dashboard)=>(
                    <div key={dashboard.urn} className="grid-item">
                      <DashboardHomeItem dashboard={dashboard} />                      
                    </div>
                  ))}
                  {domainDash[domain].length === 0 ? <span>Nenhum item correspondente à pesquisa.</span> : ""}
                </div>
            </div>
          ))}
          {/* {Object.keys(domainDash).map((domain) => {
            if(domain === 'Serviços Urbanos'){
              return <div>
                      <strong>{domain}</strong>
                        <div>
                          {domainDash[domain].map((dashboard)=>(
                            <div key={dashboard.urn} className="grid-item">
                              <DashboardHomeItem dashboard={dashboard} />                      
                            </div>
                          ))}
                          {domainDash[domain].length === 0 ? <span>Nenhum item correspondente à pesquisa.</span> : ""}
                        </div>
                    </div>
            }
            return <></>
          })}
          {Object.keys(domainDash).map((domain) => {
            if(domain !== 'Serviços Urbanos'){
              return <div>
                      <strong>{domain}</strong>
                        <div>
                          {domainDash[domain].map((dashboard)=>(
                            <div key={dashboard.urn} className="grid-item">
                              <DashboardHomeItem dashboard={dashboard} />                      
                            </div>
                          ))}
                          {domainDash[domain].length === 0 ? <span>Nenhum item correspondente à pesquisa.</span> : ""}
                        </div>
                    </div>
            }
            return <></>
          })} */}
        </div>
      </main>
      <aside>
        {/* <Collapsible title=""><Twitter/></Collapsible> */}
      </aside>
    </div>
  );
}

export default Home;
